const React = require('react');
const { useState, useEffect } = React;
const SelectField = require('hooks/useFormPrimitives/ControlledSelectField');
const { context } = require('app-context');
const { useAppSelector } = require('utils/redux');

module.exports = function ParticipationPreference() {

    const user = useAppSelector(context.selectors.all.getCurrentUserObject);
    const schoolId = useAppSelector(context.selectors.all.getCurrentSchoolId);
    const eligible = schoolId === 240394 && user?.roleId === 2;
    const [summary, setSummary] = useState(null);
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    useEffect(() => {

        let current = true;
        setSummary(null);
        setMessage('');
        if (eligible) {
            context.api.nearpeer.gamification.summary().then((data) => current && setSummary(data)).catch(() => {});
        }
        return () => { current = false; };
    }, [eligible, schoolId, user?.id]);

    if (!eligible || !summary?.enabled) { return null; }

    return <section style={{ width: '100%', marginTop: 14 }}><h3 style={{ marginBottom: 0 }}>Points &amp; medals</h3><SelectField
        id='gamification-participation'
        label='Would you like to participate in points, medals, and leaderboards?'
        value={summary.optedOut ? 'off' : 'on'}
        options={[{ value: 'on', label: 'Yes' }, { value: 'off', label: 'No' }]}
        textFieldProps={{ disabled: busy, variant: 'filled' }}
        onChange={async (value) => {

            const optedOut = value === 'off';
            setBusy(true);
            setMessage('');
            try {
                await context.api.nearpeer.gamification.participation(optedOut);
                window.dispatchEvent(new Event('gamification-participation'));
                setSummary((previous) => ({ ...previous, optedOut }));
                setMessage('Saved');
            }
            catch (error) { setMessage('Unable to save. Please try again.'); }
            finally { setBusy(false); }
        }}
    /><span role='status'>{message}</span></section>;
};
